import { useStaticQuery, graphql } from 'gatsby';

export const useMenuData = () => {
  const {
    wpgraphql: {
      menus: { nodes },
    },
  } = useStaticQuery(
    graphql`
      query MenuQuery {
        wpgraphql {
          menus {
            nodes {
              menuItems(where: { parentId: "null" }) {
                nodes {
                  url
                  title
                  target
                  path
                  order
                  label
                  linkRelationship
                  description
                  parentId
                  childItems {
                    nodes {
                      url
                      title
                      target
                      path
                      order
                      label
                    }
                  }
                }
              }
              locations
              name
              slug
            }
          }
        }
      }
    `
  );

  return nodes;
};
